
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.32 9.023c0 .308.016.553.047.735.037.182.089.328.156.437.073.104.17.188.29.25.12.058.307.115.562.172V11H.945v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.945.72V.336H4.82c1.22 0 2.125.234 2.72.703.598.464.897 1.172.897 2.125 0 .542-.093 1.029-.28 1.461a2.728 2.728 0 01-.798 1.063c-.343.276-.75.473-1.218.593-.47.12-.961.18-1.477.18-.578 0-1.026-.01-1.344-.031v2.593zm0-3.242h.907c.588 0 1.072-.075 1.453-.226.385-.157.68-.412.883-.766.203-.36.304-.833.304-1.422 0-.448-.06-.82-.18-1.117a1.811 1.811 0 00-.5-.727 1.771 1.771 0 00-.75-.382 3.676 3.676 0 00-.953-.118c-.515 0-.903.01-1.164.032V5.78z","fill":"currentColor"}})])
          )
        }
      }
    